import { Pressable } from 'react-native';

import { HStack, Text } from '@squire/ui';

import { CloseIcon, InfoCircleIcon } from '@/components/_icons';

import { styles } from './styles';
import type { InfoNoticeProps } from './types';

/**
 * Muted informational panel — an info icon beside a short explanation. Used for
 * checkout notices such as when a card is charged, or why a discount doesn't
 * apply.
 */
const InfoNotice = ({
  message,
  onDismiss,
  dismissAccessibilityLabel,
  testID = 'info-notice',
}: InfoNoticeProps) => (
  <HStack style={styles.container} testID={testID}>
    <InfoCircleIcon size={16} color="textSecondary" />
    <Text variant="m" color="textSecondary" style={styles.message}>
      {message}
    </Text>
    {onDismiss && (
      <Pressable
        onPress={onDismiss}
        hitSlop={8}
        accessibilityRole="button"
        accessibilityLabel={dismissAccessibilityLabel}
        testID={`${testID}-dismiss`}
      >
        <CloseIcon size={12} color="textSecondary" />
      </Pressable>
    )}
  </HStack>
);

InfoNotice.displayName = 'InfoNotice';
export { InfoNotice };
